<script setup lang="ts">
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import { StackLayout } from '@/components/Layouts'
import type { DeviceModel } from '@/types/models/DeviceModel'
import type { AlertSocketMessageModel } from '@/types/socket/SocketAlertModel'
import DeviceTechnicalInformations from './components/DeviceTechnicalInformations.vue'

type Props = {
    data: Partial<DeviceModel>
    status?: AlertSocketMessageModel
}
defineProps<Props>()

defineEmits<{ (e: 'update', deviceValue: Partial<DeviceModel>): void }>()
</script>

<template>
    <InformationBaseCard
        class="full-width"
        :label="$t('device.detail.informations.informationsTitle')">
        <StackLayout direction="column" :gap="8" class="full-width">
            <DeviceTechnicalInformations :data="data" :status="status">
                <slot />
            </DeviceTechnicalInformations>
        </StackLayout>
    </InformationBaseCard>
</template>
